import { queryPipelines } from '@/features/pipelines/data';
import { buildMetricsDateRange } from '@/shared/utils/metricsRange';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { PipelineListItemDto, QueryResult } from '@flowqa/shared';

export const fetchPipelinesGrid = async (
  projectId?: string | null,
  organisationId?: string | null,
  input?: GridQueryInput,
  includeDeltas = true,
): Promise<QueryResult<PipelineListItemDto>> => {
  const resolvedInput = input ?? { page: 1, pageSize: 50, sorts: [], filters: [] };
  const resolvedSorts =
    resolvedInput.sorts.length > 0
      ? resolvedInput.sorts
      : [{ field: 'latestRunTimestamp', direction: 'desc' as const }];
  const metricsRange = buildMetricsDateRange();
  return await queryPipelines(projectId, organisationId, {
    ...resolvedInput,
    sorts: resolvedSorts,
    ...metricsRange,
    include: {
      latestRun: true,
      runSummaries: true,
      metrics: true,
      metricDeltas: includeDeltas,
    },
  });
};
